export default __webpack_public_path__ + "static/media/icon-facebook.4333c445.svg";